import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type CheckboxRadioItemProps = {
  onAddRadioItem: (item: any) => void;
  item: any;
  checked: boolean;
  secondaryQ: boolean;
  name: string;
};

export function CheckboxRadioItem({
  onAddRadioItem,
  item,
  checked,
  secondaryQ,
  name,
}: CheckboxRadioItemProps) {
  const domId = secondaryQ && !item.id.endsWith('_sq') ? `${item.id}_sq` : item.id;

  function setRadioHandler(event: React.MouseEvent<HTMLInputElement>) {
    const newItem = {
      add: (event.target as HTMLInputElement).checked,
      id: item.id,
      title: item.title,
    };
    onAddRadioItem(newItem);
  }

  return (
    <div className="checkbox_item">
      <input
        type="radio"
        name={name}
        id={domId}
        className="fdatacollect"
        onClick={(e) => {
          e.stopPropagation();
          setRadioHandler(e);
        }}
        onChange={(e) => {
          e.stopPropagation();
        }}
        value={item.id}
        checked={checked}
      />
      <label htmlFor={domId} id={`${item.title.replace(/\s+/g, '_')}_label`}>
        <FontAwesomeIcon icon={faCheckCircle} className="icon" />
        {item.title}
      </label>
    </div>
  );
}
